export default __webpack_public_path__ + "static/media/UMN-Framework for Planning-05.9209b40f.jpg";